import Environment from '@zazuko/env-core';
export default Environment;
